import React, { Component } from 'react';
import { Select } from '@cimpress/react-components';

const disabledValue = { value: 'one', label: 'One' };

export default class SelectDemo extends Component {
  state = {
    options: [
      { value: 'one', label: 'One' },
      { value: 'two', label: 'Two' },
      { value: 'three', label: 'Three' },
      { value: 'four', label: 'Four' },
      { value: 'five', label: 'Five' },
    ],
    selectedSingle: undefined,
    selectedMulti: undefined,
    selectedBlur: undefined,
  };

  onSingleSelectionChange = selectedSingle => {
    this.setState({ selectedSingle });
  };

  onMultiSelectionChange = selectedMulti => {
    this.setState({ selectedMulti });
  };

  onBlurSelectionChange = (selectedBlur, action) => {
    // v. ^2.0 does not support onBlurResetsInput so the following workaround is required to preserve inputs on blur
    if (action.action !== 'input-blur' && action.action !== 'menu-close') {
      this.setState({ selectedBlur });
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6">
            <Select
              isClearable
              label="Select a thing"
              value={this.state.selectedSingle}
              options={this.state.options}
              onChange={this.onSingleSelectionChange}
              helpText="You can select a single thing from here."
            />
          </div>
          <div className="col-md-6">
            <Select
              isClearable
              label="Select many things"
              value={this.state.selectedMulti}
              options={this.state.options}
              onChange={this.onMultiSelectionChange}
              isMulti
              helpText="You can select multiple things from here."
            />
          </div>
          <div className="col-md-6">
            <Select
              isClearable
              label="On Blur Test"
              value={this.state.selectedBlur}
              inputValue={this.state.selectedBlur}
              options={this.state.options}
              onInputChange={this.onBlurSelectionChange}
              helpText="Type something and then click outside to test blur."
            />
          </div>
          <div className="col-md-6">
            <Select
              isDisabled
              isClearable
              label="Disable Test"
              value={disabledValue}
              options={this.state.options}
              menuPortalTarget={document.body}
              onBlurResetsInput={false}
              helpText="You can't select anything because the select is disabled."
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <Select
              isMulti
              isClearable
              label="Select many things"
              value={this.state.selectedMulti}
              options={this.state.options}
              onChange={this.onMultiSelectionChange}
              status="success"
              helpText="You can safely select multiple things from here."
            />
          </div>
          <div className="col-md-4">
            <Select
              isClearable
              label="Select a thing"
              value={this.state.selectedSingle}
              options={this.state.options}
              onChange={this.onSingleSelectionChange}
              status="warning"
              helpText="You need to cautiously select a single thing from here."
            />
          </div>
          <div className="col-md-4">
            <Select
              isClearable
              label="Select a thing"
              value={this.state.selectedSingle}
              options={this.state.options}
              onChange={this.onSingleSelectionChange}
              status="error"
              helpText="It is dangerous to select anything."
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
